import axios from 'axios';
import moment from 'moment';
import * as types from '../constants';

export function fetchAvailabilityOneDivision(permitId, divisionId, startDate, endDate, commercialAccountFlag, keyName = 'availability') {
  return (dispatch) => {
    return axios.get(
      `${process.env.API}/permits/${permitId}/divisions/${divisionId}/availability?start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}&commercial_acct=${!!commercialAccountFlag}`
    )
    .then((success) => {
      const avail = {};
      Object.keys(success.data.payload.date_availability).forEach((x) => {
        avail[moment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] = success.data.payload.date_availability[x].remaining > 0;
      });
      const availNums = {};
      Object.keys(success.data.payload.date_availability).forEach((x) => {
        availNums[moment.utc(x).format('MM/DD/YYYY')] = success.data.payload.date_availability[x].remaining;
      });
      dispatch({
        type: types.GET_AVAILABILITY_ONE_DIVISION,
        keyName,
        permitId,
        divisionId,
        payload: {
          bools: avail,
          nums: availNums,
          quota_type_maps: success.data.payload.quota_type_maps
        }
      });
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        dispatch({ type: types.GET_AVAILABILITY_ERROR, keyName, permitId, divisionId, payload: 'error while fetching data', error: error.response.data });
      }
    });
  };
}

export function clearAvailabilitiesMap() {
  return  (dispatch) => {
    dispatch({ type: types.CLEAR_AVAILABILITIES, payload: {} });
  };
}

export function fetchAvailabilityAllDivisions(permitId, startDate, keyName, isCommercial, addQuotaId) {
  return (dispatch) => {
    const addQuotaIdQuery = addQuotaId ? `&add_quota_id=${addQuotaId}` : '';
    const startOfMonth = moment(startDate).utc().startOf('month').startOf('day').toISOString()
    return axios.get(`${process.env.API}/permits/${permitId}/availability/month?start_date=${startOfMonth}&commercial_acct=${isCommercial}${addQuotaIdQuery}&is_lottery=false`)
      .then((success) => {
        const availabilities = {};
        Object.keys(success.data.payload.availability).forEach((divisionId) => {
          const divisionAvail = success.data.payload.availability[divisionId];
          const bools = {};
          const nums = {};
          const availNums = {};
          const walkUps = {};
          Object.keys(divisionAvail.date_availability).forEach((x) => {
            bools[moment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] = divisionAvail.date_availability[x].remaining > 0;
            nums[moment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] = divisionAvail.date_availability[x].remaining;
            availNums[moment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] = divisionAvail.date_availability[x].remaining;
            if (divisionAvail.date_availability[x].show_walkup) {
              walkUps[moment.utc(x).format(types.AVAILABILITY_KEY_MAP_FORMAT)] = divisionAvail.date_availability[x].show_walkup;
            }
          });

          const quotaTypeMaps = divisionAvail.quota_type_maps;

          const singleDivisionObj = {
            divisionId,
            permitId,
            result: {
              bools,
              nums,
              walkUps,
              quota_type_maps: quotaTypeMaps
            }
          };
          availabilities[divisionId] = singleDivisionObj;
        });
        dispatch({ type: types.GET_ALL_AVAILABILITIES, keyName, payload: availabilities });
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({ type: types.GET_ALL_AVAILABILITIES_ERROR, payload: 'error while fetching data', error: error.response.data });
        }
      });
  };
}
